
import g from "../globals/variables";

const Accordion = (target) => {

  const el = {
    accordion: target,
    accordionContainer: target.querySelector(".accordion__container"),
    accordionItems: target.querySelectorAll(".accordion__item"),
  };

  const method = {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    init: (_accordion) => {

      const allPanelElements = el.accordionItems;

      function showPanel(panelHeader) {
        const panel = panelHeader.parentNode;
        const panelBody = panelHeader.nextElementSibling;
        const expandedPanel = document.querySelector(".accordion__item.open") as HTMLElement;

        const isActive = !!((expandedPanel && panel.classList.contains("open")));

        if (expandedPanel) {
          expandedPanel.classList.remove("open");
        }

        if (panel && !isActive) {
          panelBody.style.height = `${panelBody.scrollHeight}px`;
          panel.classList.add("open");
        }

        setTimeout(() => g.scroll.update(), 600);
      }

      function handlePanelClick(event) {
        showPanel(event.currentTarget);
      }

      for (let i = 0; i < allPanelElements.length; i++) {
        allPanelElements[i].querySelector(".accordion__header").addEventListener("click", handlePanelClick);
      }

      showPanel(allPanelElements);
    },

  };

  method.init(el.accordion);
};

export default Accordion;
